<template>
  <div class="py-4">
    <template v-for="(button, index) in buttons">
      <button
        :key="index"
        v-on:click="submitButton(button)"
        :class="`${setColor(button)} mr-2 border rounded-md shadow-sm py-2 px-4 inline-flex justify-center 2xl:text-sm sm:text-xl font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500 disabled:opacity-50`"
        ß>
        {{button.label}}
      </button>
    </template>
  </div>
</template>
<script>
export default {
  name: 'buttons-field',
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    },
    params: {
      field: {
        type: Object
      }
    }
  },
  mounted(){
    this.getButtons()
  },
  data() {
    return {
      buttons: [],
      colors: {
        'blue': 'bg-light-blue-700 border-transparent text-white hover:bg-light-blue-800 focus:ring-light-blue-500',
        'red': 'bg-red-500 border-transparent text-white hover:bg-red-600 focus:ring-red-300',
        'white': 'border-gray-300 text-gray-700 hover:bg-gray-50 bg-white'
      }
    }
  },
  methods: {
    async getButtons(){
      console.log("getButtons");
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          ...this.params,
          blueprint: this.$route.params.blueprint,
          record: this.$route.params.record,
          query: this.$route.query
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.buttons = response.data
    },
    setColor(button){
      if (button.options_render === 'undefined'){
        return this.colors.white
      }
      if (button.options_render.color === 'undefined' || button.options_render.color === ''){
        return this.colors.white
      }
      return this.colors[button.options_render.color]
    },
    submitButton(button){
      this.$parent[button.action](button)
    }
  }
}
</script>
